"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textEllipsis = void 0;
const textEllipsis = (text, max) => (text.length > max ? `${text.substring(0, max)}...` : text);
exports.textEllipsis = textEllipsis;
